import api from "./api"

export const getAddrTreeAPI = async () => {
  const { data } = await api.get(`/api/apt`)
  return data
}

export const getAptSearchAPI = async ({ addr_codes, keyword }) => {
  const { data } = await api.post("/api/apt/search-batch", {
    addr_codes,
    keyword
  })
  return data
}

export const getSidoByIdsAPI = async (kapt_codes) => {
  const { data } = await api.post("/api/apt/by-ids", {
    kapt_codes
  })

  return data
}

export const getAptByPathAPI = async ({ kapt_code }) => {
  const { data } = await api.get(`/api/apt/by-path`, {
    params: { kapt_code }
  })
  return data
}

export const getDongInfoAPI = async ({ kapt_code }) => {
  const { data } = await api.get(`/api/apt/${kapt_code}/dong-info`)
  return data
}

export const getDongHoInfoAPI = async ({ kapt_code }) => {
  const { data } = await api.get(`/api/apt/${kapt_code}/dongho-info`)
  return data
}

//INFO: overview 개요
export const getKpiMetricAPI = async ({ sido, kapt_code, ended_at }) => {
  const { data } = await api.get("/api/overview/kpi", {
    params: { sido, kapt_code, ended_at }
  })
  return data
}

export const getResourceTrendAPI = async ({ sido, kapt_code, period, ended_at }) => {
  const { data } = await api.get("/api/overview/trend", {
    params: { sido, kapt_code, period, ended_at }
  })
  return data
}

export const getTopUsageRankAPI = async ({ sido, kapt_code, ended_at }) => {
  const { data } = await api.get("/api/overview/top-rank", {
    params: { sido, kapt_code, ended_at }
  })
  return data
}

export const getNegativeUsageAPI = async ({ sido, kapt_code, ended_at }) => {
  const { data } = await api.get("/api/overview/negative", {
    params: { sido, kapt_code, ended_at }
  })
  return data
}

export const getAptSizeMapAPI = async ({ kapt_code }) => {
  const { data } = await api.get("/api/monitoring", {
    params: { kapt_code }
  })
  return data
}

// INFO: report 통계
export const getReportDataAPI = async ({ sido, kapt_code, start_date, end_date, resource }) => {
  const { data } = await api.get("/api/report", {
    params: { sido, kapt_code, start_date, end_date, resource }
  })
  return data
}

// INFO: analyis 분석
export const getLeakRawAPI = async ({ sido, kapt_code, dong, ho, start_date, end_date }) => {
  const { data } = await api.get("/api/unit/usage/raw", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      start_date,
      end_date,
      resource: "water"
    }
  })
  return data
}

export const getLeakDongMapAPI = async ({ sido, kapt_code }) => {
  const { data } = await api.get("/api/analysis/leak/dong-map", {
    params: { sido, kapt_code }
  })
  return data
}

// INFO: units 세대조회
export const getLeakUnitsAPI = async ({ sido, kapt_code, dong }) => {
  const { data } = await api.get("/api/analysis/leak", {
    params: { sido, kapt_code, dong }
  })
  return data
}

export const getOveruseUnitsAPI = async ({ sido, kapt_code, dong }) => {
  const { data } = await api.get("/api/analysis/overuse", {
    params: { sido, kapt_code, dong }
  })
  return data
}

export const getUsageSummaryAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  resource = "water",
  start_date,
  end_date,
  group_scope = "apt"
}) => {
  const { data } = await api.get("/api/unit/usage/summary", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      resource,
      start_date,
      end_date,
      group_scope
    }
  })
  return data
}

export const getUsageRawAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  start_date,
  end_date,
  resource
}) => {
  const { data } = await api.get("/api/unit/usage/raw", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      start_date,
      end_date,
      resource
    }
  })
  return data
}

export const getWeekdayCompareAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  target_date,
  resource = "water"
}) => {
  const { data } = await api.get("/api/unit/weekday/compare", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      target_date,
      resource
    }
  })
  return data
}

export const getWeekdayDetailAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  target_date,
  resource = "water"
}) => {
  const { data } = await api.get("/api/unit/weekday/detail", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      target_date,
      resource
    }
  })
  return data
}

export const getPatternClockAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  target_date,
  resource = "water"
}) => {
  const { data } = await api.get("/api/unit/pattern-clock", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      target_date,
      resource
    }
  })
  return data
}
